module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "back-button right mb11",
    attrs: {
      "tag": "a",
      "to": "/portfolio"
    }
  }, [_vm._v("Back to portfolio")]), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("PARKS")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "portfolio-list"
  }, [_c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Parks/parks1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Friends of Broadneck Park")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Annapolis, MD")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Parks/parks2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Friends of the Park")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Lambertville, NJ")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Parks/parks3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Children’s Memorial Park")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Virginia, MN")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c0c4366","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/our-work/Parks.vue
// module id = AwP2
// module chunks = 1